import {FC} from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import RichText from "../../../components/content/RichText";
import PreviewTag from "../../../components/PreviewTag";

type Props = {
    title?: string;
    originalPath?: string;
    contentBlock?: string;
    isPreview?: boolean | null;
}
const MAX_LENGTH = 100;

const parseImg = (content?: string) => {
    const imgMatch = content?.match(/<img\b[^>]*\/?>/i);
    const rawImgTag = imgMatch ? imgMatch[0] : undefined;
    const imgTag = rawImgTag?.replace(/\sstyle\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');
    return {
        rawImgTag,
        imgTag
    }
}

const CodeDetailsRelatedContentCmsSubpage: FC<Props> = ({title, originalPath, contentBlock, isPreview}) => {
    const navigate = useNavigate();
    const {rawImgTag, imgTag} = parseImg(contentBlock);
    const cleanedContentBlock = imgTag ? contentBlock?.replace(rawImgTag!, imgTag) : contentBlock;
    const limitedContentBlock = cleanedContentBlock && cleanedContentBlock.length > MAX_LENGTH
        ? cleanedContentBlock.slice(0, MAX_LENGTH) + "..."
        : cleanedContentBlock;
    return (
        <Box onClick={() => navigate(`${originalPath}`)}
             sx={{cursor: "pointer", backgroundColor: "background.paper", padding: 1}}>
            <Grid container>
                <Grid item xs={4}>
                    {imgTag && (
                        <Box
                            sx={{
                                "& img": {
                                    width: "100% !important",
                                    objectFit: "contain",
                                    pl: 1
                                }
                            }}
                            dangerouslySetInnerHTML={{__html: imgTag}}
                        />
                    )}
                </Grid>
                <Grid item xs={8} paddingLeft={2.5}>
                    <PreviewTag isPreview={isPreview} sx={{ mb: 0.5 }} />
                    <Typography variant="h5">{title}</Typography>
                    <RichText
                        html={limitedContentBlock}
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            height: "fit-content",
                            WebkitBoxOrient: "vertical",
                            "& .MuiTypography-root": {
                                fontWeight: "normal !important",
                                fontSize: "1rem !important"
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default CodeDetailsRelatedContentCmsSubpage;